import React from 'react';
import { RootState } from 'reducers';
import { connect } from 'react-redux';
import { Input, Pagination, Select, Tooltip } from 'components';
// NOTA: ChatService se quitó de este import porque la creación del chat
// (ChatService.save) ahora ocurre en chat.tsx al enviar el primer mensaje,
// no aquí. Si se vuelve a necesitar ChatService en este archivo, reagregarlo.
import { GeneralService, UserService } from 'services';
import {
  ArrowRightBlack,
  BackIcon,
  CallIcon,
  ChatIcon,
  CheckGreenCircle,
  CleanIcon,
  CloseIcon,
  MailIcon,
  PhoneIcon,
  StarActiveIcon,
} from 'assets/icons';
import { Globals } from 'utils';
import COUNTRIES from 'utils/countries';
import { withRouter } from 'react-router-dom';
import { Constants } from 'utils';

interface Props extends RootState {
  onClose?: any;
  navigation?: any;
  dispatch?: any;
}

const SCOPE = {
  NATIONAL: 'NATIONAL',
  INTERNATIONAL: 'INTERNATIONAL',
};

const INITIAL_STATE = {
  search: '',
  area_id: '',
  scope: SCOPE.NATIONAL,
  state_id: '',
  country: '',
};

const STEPS = {
  ALL_LAWYERS: 'ALL_LAWYERS',
  LAWYER_DETAILS: 'LAWYER_DETAILS',
};

const getLocationText = (item: any) => {
  if (item?.country && item.country !== 'VE') {
    return COUNTRIES.find((c: any) => c.value === item.country)?.label || item.country;
  }

  const parts = ['Venezuela', item?.state?.name, item?.city?.name].filter(Boolean);

  return parts.join(' - ');
};

class ModalLawyers extends React.Component<Props> {
  state = {
    steps: STEPS.ALL_LAWYERS,
    form: INITIAL_STATE,
    data: [],
    areas: [],
    states: [],
    page: 1,
    last_page: 1,
    openItem: null,
    item: null,
    ratingData: null,
  };

  componentDidMount() {
    this.getSelects();
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    try {
      const { search, area_id, scope, state_id, country } = this.state.form;

      const params: any = {
        withoutLoading,
        page: this.state.page,
        user_id: this.props.user?.id,
        area_id,
        scope,
        search: search || undefined,
      };

      if (scope === SCOPE.NATIONAL) {
        params.state_id = state_id;
      } else if (scope === SCOPE.INTERNATIONAL) {
        params.country = country;
      }

      const res: any = await UserService.client.get(params);

      this.setState({
        data: res.rows,
        last_page: res.count,
      });
    } catch (error) {}
  };

  change = (e: any) => {
    const { name, value } = e.target;

    this.setState(
      {
        form: {
          ...this.state.form,
          [name]: value,
          ...(name === 'scope' ? { state_id: '', country: '' } : {}),
        },
        page: 1,
      },
      () => this.load(true),
    );
  };

  changeSearch = (e: any) => {
    const value = e.target.value;

    this.setState({
      form: {
        ...this.state.form,
        search: value,
      },
    });
  };

  submitSearch = () => {
    this.setState({ page: 1 }, () => this.load(true));
  };

  clearSearch = () => {
    if (!this.state.form.search) return;

    this.setState(
      {
        form: { ...this.state.form, search: '' },
        page: 1,
      },
      () => this.load(true),
    );
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  getSelects = async () => {
    const res: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      area: true,
      state: true,
    });
    this.setState({
      areas: res.areas || [],
      states: res.states || [],
    });
  };

  showLawyerDetail = (item: any) => {
    this.setState({
      steps: STEPS.LAWYER_DETAILS,
      item,
      ratingData: null,
    });

    UserService.client
      .getLawyer({ id: item.id })
      .then((res: any) => this.setState({ ratingData: res }))
      .catch((e: any) => console.log('modal-lawyers getLawyer (rating) error:', e));
  };

  back = () => {
    this.setState({
      steps: STEPS.ALL_LAWYERS,
      item: null,
      ratingData: null,
    });
  };

  /**
   * Ahora solo navegamos a la pantalla de chat. El abogado elegido
   * se guarda en Redux (action SET_PENDING_LAWYER,chat.tsx lee
   * this.props.pending_lawyer (vía connect) para armar el chat "pendiente "
   * (sin chat_id todavía). El chat real (ChatService.save, con el mensaje
   * incluido) se crea recién cuando el usuario envía su primer mensaje.
   */
  goToChat = () => {
    const item: any = this.state.item;
    if (!item) return;

    this.props.dispatch({
      type: 'SET_PENDING_LAWYER',
      payload: {
        id: item.id,
        full_name: item.full_name,
        photo: item.photo,
      },
    });

    this.props.navigation.push('/client/chat');
  };

  render() {
    const lawyer: any = this.state.item;
    const canSeeContactInfo = (this.props as any).plan_user?.membership?.is_free !== true;

    return (
      <div id='modal-search-lawyers'>
        <div className='row header'>
          <div className='col-10 title-container'>
            {this.state.steps == STEPS.LAWYER_DETAILS && (
              <button className='btn' onClick={this.back}>
                <img src={BackIcon} />
              </button>
            )}
            <div>
              <div className='name-row'>
                <h3 className='title'>{lawyer?.full_name ?? 'Ubica tu abogado'}</h3>
              </div>
              {lawyer && lawyer?.gender_text && <p className='subtitle'>{lawyer?.gender_text}</p>}
            </div>
          </div>
          <div className='col-2 text-right'>
            <button className='btn btn-close' onClick={() => this.props.onClose()}>
              <img src={CloseIcon} />
            </button>
          </div>
        </div>
        {this.state.steps == STEPS.ALL_LAWYERS && (
          <>
            <div className='filters'>
              <Input
                name='search'
                color='white'
                className='search-full-width'
                placeholder='Buscar'
                value={this.state.form.search}
                onChange={(e: any) => this.changeSearch(e)}
                onKeyDown={(e: any) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    this.submitSearch();
                  }
                }}
                searchRight={true}
                searchIcon={this.state.form.search ? CloseIcon : undefined}
                onSubmit={() => this.clearSearch()}
              />
              <Select
                color='white'
                placeholder='Área legal'
                name='area_id'
                onChange={(e) => this.change(e)}
                value={this.state.form.area_id}
                options={this.state.areas.map((item: any) => {
                  return {
                    value: item.id,
                    label: item.name,
                  };
                })}
              />
              <Select
                color='white'
                placeholder='Ubicación'
                name='scope'
                onChange={(e) => this.change(e)}
                value={this.state.form.scope}
                options={[
                  { value: SCOPE.NATIONAL, label: 'Venezuela' },
                  {
                    value: SCOPE.INTERNATIONAL,
                    label: 'Exterior',
                  },
                ]}
              />
              {this.state.form.scope === SCOPE.INTERNATIONAL ? (
                <Select
                  color='white'
                  placeholder='País'
                  name='country'
                  onChange={(e) => this.change(e)}
                  value={this.state.form.country}
                  options={COUNTRIES.filter((c: any) => c.value !== 'VE').map((item: any) => {
                    return {
                      value: item.value,
                      label: item.label,
                    };
                  })}
                />
              ) : this.state.form.scope === SCOPE.NATIONAL ? (
                <Select
                  color='white'
                  placeholder='Estado'
                  name='state_id'
                  onChange={(e) => this.change(e)}
                  value={this.state.form.state_id}
                  options={this.state.states.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              ) : null}

              <div className='filter-actions'>
                <button
                  className='btn btn-clean'
                  onClick={() => this.reset()}
                  disabled={JSON.stringify(this.state.form) === JSON.stringify(INITIAL_STATE)}
                  title='Limpiar filtros'
                >
                  <img src={CleanIcon} />
                </button>
              </div>
              <div className='container-items'>
                {!!this.state.data.length ? (
                  this.state.data.map((item: any) => {
                    /* @ts-ignore */
                    return (
                      <div className='item' onClick={() => this.showLawyerDetail(item)}>
                        <div className='main-info'>
                          <div>
                            <div className='name-row'>
                              <p className='name'>{item.full_name}</p>
                              <div className='rating rating-inline'>
                                <p>
                                  {item.avgRating
                                    ? Globals.formatMiles(item.avgRating, true, '')
                                    : 'Sin calificación'}
                                </p>
                                <img src={StarActiveIcon} />
                              </div>
                            </div>
                            <p className='state'>{getLocationText(item)}</p>
                            <span
                              className={`verified-tag ${item.verified === Constants.VERIFIED.VERIFIED ? 'active' : 'inactive'}`}
                            >
                              {item.verified === Constants.VERIFIED.VERIFIED
                                ? 'Verificado'
                                : 'No verificado'}
                            </span>
                          </div>
                          <Tooltip title={'Ver más'}>
                            <img className={`show-more`} src={ArrowRightBlack} />
                          </Tooltip>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className='no-items'>
                    <p>No hay abogados</p>
                  </div>
                )}
              </div>
            </div>
            <Pagination
              pages={this.state.last_page}
              active={this.state.page}
              onChange={async (page: number) => {
                await this.setState({
                  page: page,
                });
                this.load();
              }}
            />
          </>
        )}

        {this.state.steps == STEPS.LAWYER_DETAILS && (
          <div className='details'>
            <div>
              <span
                className={`verified-tag ${lawyer?.verified === Constants.VERIFIED.VERIFIED ? 'active' : 'inactive'}`}
              >
                {lawyer?.verified === Constants.VERIFIED.VERIFIED ? 'Verificado' : 'No verificado'}
              </span>
            </div>

            <div className='rating'>
              <p>
                {(this.state.ratingData as any)?.avgRating
                  ? Globals.formatMiles((this.state.ratingData as any)?.avgRating, true, '')
                  : 'Sin calificación'}
              </p>
              <img src={StarActiveIcon} />
              {!!(this.state.ratingData as any)?.avgRating &&
                !!(this.state.ratingData as any)?.ratingCount && (
                  <span className='rating-count'>
                    ({(this.state.ratingData as any).ratingCount}{' '}
                    {(this.state.ratingData as any).ratingCount === 1 ? 'voto' : 'votos'})
                  </span>
                )}
            </div>

            <div className='info'>
              <p className='subtitle'>Especialidad</p>
              <p>{lawyer?.user_areas?.map((i: any) => i.area?.name).join(', ')}</p>
            </div>

            <div className='info'>
              <p className='subtitle'>Dirección</p>
              <p>{getLocationText(lawyer)}</p>
            </div>

            {lawyer?.experience_text && (
              <div className='info'>
                <p className='subtitle'>Experiencia</p>
                <p>{lawyer?.experience_text}</p>
              </div>
            )}
            {lawyer?.biography && (
              <div className='info'>
                <p className='subtitle'>Biografía</p>
                <p className='biography'>{lawyer?.biography}</p>
              </div>
            )}

            <div className='list-container'>
              {lawyer?.has_membership ? (
                <>
                  <div
                    className='chat'
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.goToChat()}
                  >
                    <img src={ChatIcon} className='icon' />
                    <p>Chatear</p>
                  </div>

                  <div className={`email${!canSeeContactInfo ? ' disguised' : ''}`}>
                    <img src={MailIcon} className='icon' />
                    {canSeeContactInfo ? (
                      <p>{lawyer?.email}</p>
                    ) : (
                      <p>Suscríbete a un plan para ver el correo</p>
                    )}
                  </div>

                  <div className={`phone${!canSeeContactInfo ? ' disguised' : ''}`}>
                    <img src={CallIcon} className='icon' />
                    {canSeeContactInfo ? (
                      <p>{lawyer?.full_phone}</p>
                    ) : (
                      <p>Suscríbete a un plan para ver el teléfono</p>
                    )}
                  </div>
                </>
              ) : (
                <div className='no-membership-notice'>
                  <p>Este abogado no tiene membresía activa</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
    plan_user: state.plan_user,
  };
})(ModalLawyers);
